import React from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@mui/styles";

import TicketsManager from "../../components/TicketsManager/";
import Ticket from "../../components/Ticket/";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "calc(100vh - 48px)",
    overflow: "hidden",
    backgroundColor: theme.palette.background.default,
  },

  // Coluna esquerda — lista de tickets
  listCol: {
    display: "flex",
    flexDirection: "column",
    width: "100%",           // toma tudo quando não há ticket aberto
    maxWidth: 420,
    borderRight: `1px solid ${theme.palette.divider}`,
    overflow: "hidden",
    flexShrink: 0,
    [theme.breakpoints.down("md")]: {
      maxWidth: "100%",
      display: ({ ticketId }) => ticketId ? "none" : "flex",
    },
  },

  // Coluna direita — chat
  chatCol: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
  },
}));

const Chat = () => {
  const { ticketId } = useParams();
  const classes = useStyles({ ticketId });

  return (
    <div className={classes.root}>
      <div
        className={classes.listCol}
        style={ticketId ? { maxWidth: 380, width: 380 } : {}}
      >
        <TicketsManager />
      </div>

      {ticketId && (
        <div className={classes.chatCol}>
          <Ticket />
        </div>
      )}
    </div>
  );
};

export default Chat;
